export default __webpack_public_path__ + "static/media/facebook.c69ec6cd.svg";